// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageRoles_root__z+7ec","tableControls":"ManageRoles_tableControls__5Sxai","search":"ManageRoles_search__00XQb","checkbox":"ManageRoles_checkbox__FL8d/"};